import type { IconSvgObject } from './types';

const ArrowDownLeft01Icon: IconSvgObject = [
  ["path", { d: "M6.50003 9V17.5H15M6.92857 17.0714L17.5 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowDownLeft01Icon;
